'use client';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { CategoryDetails, LinkComponent} from "../../../types";
import ServiceTile from "../service-tile/ServiceTile";

type ServiceCarouselTypes = {
    serviceCategory: CategoryDetails;
    Link?: LinkComponent;
};

const ServiceCarousel = ({ serviceCategory, Link  }: ServiceCarouselTypes) => {

    return (
        <div className="hidden md:block w-full max-w-6xl mx-auto py-10">
            <Swiper
                loop={true}
                dir="rtl"
                modules={[Autoplay]}
                speed={6000}
                autoplay={{
                    delay: 1,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                }}
                allowTouchMove={true}
                className="swiper-top"
                breakpoints={{
                    0: { slidesPerView: 1.5, spaceBetween: 10 },
                    550: { slidesPerView: 2.2, spaceBetween: 15 },
                    670: { slidesPerView: 3, spaceBetween: 15 },
                    1000: { slidesPerView: 4, spaceBetween: 10 },
                }}
            >
                {serviceCategory?.subCategories.map((s, i) => (
                    <SwiperSlide key={`${s.id}-${i}`}>
                        <ServiceTile
                            service={s}
                            height="200px"
                            width="100%"
                            isBackground={true}
                            Link={Link}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );

};

export default ServiceCarousel;
